import { Col, Row, Table, Tooltip } from "antd";
import {
  DeleteOutlined,
  UploadOutlined,
  LinkOutlined
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Button, Modal, Upload } from "antd";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { DashboardServices } from "../../../redux/Services";
import AbhaLinkedFilter from "../AbhaFilter";
import moment from "moment";
const HipContestGrant = () => {
  const filename = "Consent Grant Logs";
  const [FilteredData, setFilteredData] = useState([]);
  const permission = usePermission("HIP Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [limit, setLimit] = useState(100);
  const ConsentRequestsLog = useSelector(
    (state) => state.dashboard.hipConstentGrantLog || []
  );
  const totalConsentRequestsLog = useSelector(
    (state) => state.dashboard.totalHipConstentGrantLog || ""
  );
  const { mutate: fetchHIPConsentGrantLog, isLoading } = useMutation((data) =>
    dispatch(DashboardServices.fetchHIPConsentGrantLogApi(data, limit, page))
  );
  const [raw, setRaw] = useState({});
  const [modal1Open, setModal1Open] = useState(false);

  useEffect(() => {
    fetchHIPConsentGrantLog(filter);
    return () => {};
  }, [filter, limit, page]);

  // console.log(totalConsentRequestsLog);

  useEffect(() => {
    if (ConsentRequestsLog && ConsentRequestsLog.length > 0) {
      var data = [];
      ConsentRequestsLog.map((value, index) => {
        var item = {
          sno: value?.sno,
          id: value?.id,
          log_type: value?.log_type,
          requestor: value?.requestor,
          patient_name: value?.patient_name,
          reference_id: value?.reference_id,
          mobile_no: value?.mobile_no,
          heathid_no: value?.heathid_no,
          health_id: value?.health_id,
          createdAt: value?.createdAt,
          updatedAt: value?.updatedAt
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [ConsentRequestsLog]);

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Log Id", key: "id" },
    { label: "Log Type", key: "log_type" },
    { label: "Requester (HIU/HIP)", key: "requestor" },
    { label: "Patient Name", key: "patient_name" },
    { label: "Patient Id", key: "reference_id" },
    { label: "Mobile Number", key: "mobile_no" },
    { label: "ABHA Number", key: "heathid_no" },
    { label: "ABHA Address", key: "health_id" },
    { label: "Created At", key: "createdAt" },
    { label: "Updated At", key: "updatedAt" }
  ];

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 100 + index + 1
    },
    {
      title: "Consent Id",
      dataIndex: "consentId",
      key: "ReferenceId",
      className: "table_status_col",
      render: (value, item, index) => {
        let data = JSON.parse(item?.response_raw_data || "{}")?.notification
          ?.consentDetail;
        return <span>{data?.consentId}</span>;
      }
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
      className: "table_status_col"
    },
    {
      title: "Request Id",
      dataIndex: "ReferenceId",
      key: "ReferenceId",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <span> {JSON.parse(item?.response_raw_data || "{}")?.requestId}</span>
        );
      }
    },
    /* {
            title: 'Log Type',
            dataIndex: 'hitypes',
            key: 'ReferenceId',
            className: 'table_status_col',
            render: (value, item, index) => {
                return (
                   <span>{item?.log_type}</span>
                )
            }
        }, */

    {
      title: "Requester (HIU/HIP)",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize"
    },
    // {
    //     title: 'Patient Name',
    //     dataIndex: 'ReferenceName',
    //     key: 'ReferenceName',
    //     className: 'table_status_col patient',
    //     render: (value, item, index) => {
    //         let data = (JSON.parse(item?.response_raw_data || "{}"))?.notification?.consentDetail;
    //         return (
    //             <span>
    //                 {data?.patient?.name}
    //             </span>
    //         )
    //     }
    // },
    {
      title: "Patient Id",
      dataIndex: "ReferenceId",
      key: "ReferenceId",
      className: "table_status_col patient",
      render: (value, item, index) => {
        let data = JSON.parse(item?.response_raw_data || "{}")?.notification
          ?.consentDetail;
        return <span>{data?.patient?.id}</span>;
      }
    },
    {
      title: "ABHA Address",
      dataIndex: "ReferenceId",
      key: "ReferenceId",
      className: "table_status_col",
      render: (value, item, index) => {
        let data = JSON.parse(item?.response_raw_data || "{}")?.notification
          ?.consentDetail;
        return <span>{data?.patient?.id}</span>;
      }
    },

    // {
    //     title: 'URL',
    //     dataIndex: 'Status',
    //     key: 'Status',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             <a href='#'>https://www.pathkindlabs.com/abha</a>
    //         )
    //     }
    // },
    {
      title: "Consent Status",
      dataIndex: "consent_status",
      key: "consent_status",
      className: "text-capitalize",
      render: (value, record, index) => {
        return record?.consent_status == "REVOKED" ? (
          <span style={{ color: "red" }}>{record?.consent_status}</span>
        ) : record?.consent_status == "GRANTED" ? (
          <span style={{ color: "green" }}>{record?.consent_status}</span>
        ) : (
          <span>{record?.consent_status}</span>
        );
      }
    },
    {
      title: "Date Time",
      dataIndex: "createdAt",
      key: "Title",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            {/* {moment.utc(JSON.parse(item?.response_raw_data || "{}")?.timestamp)}
             */}
            <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>
          </span>
        );
      }
    },
    // {
    //     title: 'Requested Data',
    //     dataIndex: 'Status',
    //     key: 'Status',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             <Button className="view-btn" type="primary" onClick={() => {setRaw(JSON.parse(item?.request_raw_data || "{}")); setModal1Open(true)}} > View</Button>
    //         )
    //     }
    // },
    {
      title: "Response Data",
      dataIndex: "Status",
      key: "Status",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <Button
            className="view-btn"
            type="primary"
            onClick={() => {
              setRaw(JSON.parse(item?.response_raw_data || "{}"));
              setModal1Open(true);
            }}
          >
            {" "}
            View
          </Button>
        );
      }
    }
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col lg={3} md={24} sm={24} xs={24}>
          <HeadingBack
            title={"Consent Grant Logs"}
            subHeading={`Records ${totalConsentRequestsLog || 0}`}
          />
        </Col>
        <Col lg={19} md={12} sm={24} xs={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            headers={headers}
            FilteredData={FilteredData}
            setFilteredData={setFilteredData}
            filename={filename}
          />
        </Col>
        {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey="Id"
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          bordered
          columns={columns}
          dataSource={
            Array.isArray(ConsentRequestsLog) && ConsentRequestsLog?.length > 0
              ? ConsentRequestsLog
              : []
          }
          pagination={{
            current: page,
            pageSize: limit,
            total: totalConsentRequestsLog,
            onChange(current, pageSize) {
              setPage(current);
            },
            hideOnSinglePage: true
            /* total: totalFaq,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        responsive: true */
          }}
        />
        <Modal
          style={{
            top: 20
          }}
          open={modal1Open}
          onOk={() => setModal1Open(false)}
          onCancel={() => setModal1Open(false)}
          footer={null}
        >
          <pre>{JSON.stringify(raw, null, 2)}</pre>
        </Modal>
      </div>
    </div>
  );
};

export default HipContestGrant;
